﻿import { AppEnvironmentEnum } from "enums/AppEnvironmentEnum";
import { environment } from "models/Environment";
import { LogLevel } from "models/LogLevel";

const startTime = new Date().getTime();

function leadZero(t: number) {
  return t < 10 ? `0${t}` : String(t);
}

function ms() {
  return `+(${new Date().getTime() - startTime}ms)`;
}

function prefix(severity: string, category: string) {
  const dt = new Date();
  const yyyy = dt.getFullYear();
  const mm = leadZero(dt.getMonth() + 1);
  const dd = leadZero(dt.getDate());
  const wd = dt.toDateString().substring(0, 3);
  const HH = leadZero(dt.getHours());
  const MM = leadZero(dt.getMinutes());
  const ss = leadZero(dt.getSeconds());
  return `${severity} ${wd}, ${yyyy}-${mm}-${dd} ${HH}:${MM}:${ss} ${ms()} \x1b[35m${category}\x1b[0m:`;
}

function getDefaultLogLevel() {
  let result = LogLevel.Debug;
  switch (environment.name) {
    case AppEnvironmentEnum.Production:
      result = LogLevel.Warn;
      break;
    case AppEnvironmentEnum.Test:
      result = LogLevel.Info;
      break;
  }

  const storageLogLevel = parseInt(window.localStorage.getItem("LogLevel") || "", 10) as LogLevel;
  if (storageLogLevel) {
    result = storageLogLevel;
  }

  return result;
}

export class Logger {
  category: string;
  logLevel: LogLevel;

  constructor(category: string, logLevel?: LogLevel) {
    this.category = category;
    this.logLevel = logLevel === undefined ? getDefaultLogLevel() : logLevel;
  }

  log(level: LogLevel, ...args: unknown[]) {
    if (this.logLevel > level) return;

    const severity = LogLevel[level].toUpperCase();
    args.unshift(prefix(severity, this.category));

    switch (level) {
      case LogLevel.Trace:
      case LogLevel.Debug:
        console.debug(...args);
        break;

      case LogLevel.Info:
        console.info(...args);
        break;

      case LogLevel.Warn:
        console.warn(...args);
        break;

      case LogLevel.Error:
        console.error(...args);
        break;
    }
  }

  trace(...args: unknown[]) {
    this.log(LogLevel.Trace, ...args);
  }

  debug(...args: unknown[]) {
    this.log(LogLevel.Debug, ...args);
  }

  info(...args: unknown[]) {
    this.log(LogLevel.Info, ...args);
  }

  warn(...args: unknown[]) {
    this.log(LogLevel.Warn, ...args);
  }

  error(...args: unknown[]) {
    this.log(LogLevel.Error, ...args);
  }
}

export function createLogger(topic: string, logLevel?: LogLevel): Logger {
  return new Logger(topic, logLevel);
}
